import React, { useEffect } from "react";
import "./about.css";
import { TbBulb } from "react-icons/tb";
import { FaPersonWalkingArrowRight } from "react-icons/fa6";
import { ScrollBasedVelocityDemo } from "../global/ScrollBasedVelocityDemo";
import ladyChef from "../assets/chef.png";

const About = () => {
  return (
    <div className="maindiv about">
      <div className="ourstorymain">
        <h2 className="text-[#fff]">Our Story</h2>
        <div className="ourstory">
          <div>
            <img src={ladyChef} alt="bhhokerChef" className="chef" />
          </div>
          <div className="ourstorytextp">
            <div>
              <div className="clip"></div>
              <p className="relative z-index-[2]">
                {" "}
                Bhookr was founded to make healthy eating joyful and convenient.
                Inspired by the challenges of balancing nutrition with busy
                schedules, our journey began as a humble kitchen and evolved
                into a dedicated cloud kitchen serving Hyderabad. We offer
                fresh, healthy, and affordable meals for professionals, fitness
                enthusiasts, and anyone seeking nutritious, delicious food. At
                Bhookr, we deliver more than meals – we deliver experiences that
                transform lives, making every bite a moment of joy and
                satisfaction.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="">
        <ScrollBasedVelocityDemo />
      </div>
      <div className="about1">
        <div className="mission">
          <div>
            {" "}
            <FaPersonWalkingArrowRight className="text-[20px] text-[#100c08]" />
            <h2>Our Mission</h2>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#100c08"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-rocket"
            >
              <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
              <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
              <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
              <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
            </svg>
          </div>
          <p>
            At Bhookr, our mission is to transform the way people experience
            healthy eating by offering nutritious, fresh, and calorie-counted
            meals that are as delicious as they are beneficial. We aim to make
            healthy food affordable, convenient, and accessible to all, without
            compromising on taste. With Bhookr, eating healthy doesn’t mean
            boring – it means fueling your body with vibrant, flavorful meals
            that help you stay fit and energized throughout your day.
          </p>

          <div className="separator">
            {" "}
            <FaPersonWalkingArrowRight className="text-[20px] text-[#100c08]" />
            <h2>Our Vision</h2>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="#fff"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-target"
            >
              <circle cx="12" cy="12" r="10" />
              <circle cx="12" cy="12" r="6" />
              <circle cx="12" cy="12" r="2" />
            </svg>
          </div>
          <p>
            At Bhookr, our mission is to transform the way people experience
            healthy eating by offering nutritious, fresh, and calorie-counted
            meals that are as delicious as they are beneficial. We aim to make
            healthy food affordable, convenient, and accessible to all, without
            compromising on taste. With Bhookr, eating healthy doesn’t mean
            boring – it means fueling your body with vibrant, flavorful meals
            that help you stay fit and energized throughout your day.
          </p>
          <div className="separator">
            {" "}
            <FaPersonWalkingArrowRight className="text-[20px] text-[#100c08]" />
            <h2>Problem We Solve</h2>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#100c08"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-hand-heart"
            >
              <path d="M11 14h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 16" />
              <path d="m7 20 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9" />
              <path d="m2 15 6 6" />
              <path d="M19.5 8.5c.7-.7 1.5-1.6 1.5-2.7A2.73 2.73 0 0 0 16 4a2.78 2.78 0 0 0-5 1.8c0 1.2.8 2 1.5 2.8L16 12Z" />
            </svg>
          </div>
          <p>
            In today’s fast-paced world, finding the time and resources to
            prepare nutritious meals can be a challenge. Most people are stuck
            between choosing unhealthy fast food or spending hours prepping and
            cooking meals. This often leads to compromised health, poor dietary
            habits, and frustration for those trying to maintain a balanced
            lifestyle.
          </p>
          <div className="separator">
            {" "}
            <FaPersonWalkingArrowRight className="text-[20px] text-[#100c08]" />
            <h2>Our Solution</h2>
            <TbBulb className="text-[30px] text-[#100c08]" />
          </div>
          <p>
            In today’s fast-paced world, finding the time and resources to
            prepare nutritious meals can be a challenge. Most people are stuck
            between choosing unhealthy fast food or spending hours prepping and
            cooking meals. This often leads to compromised health, poor dietary
            habits, and frustration for those trying to maintain a balanced
            lifestyle.
          </p>
          <ul>
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#fff"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-biceps-flexed"
              >
                <path d="M12.409 13.017A5 5 0 0 1 22 15c0 3.866-4 7-9 7-4.077 0-8.153-.82-10.371-2.462-.426-.316-.631-.832-.62-1.362C2.118 12.723 2.627 2 10 2a3 3 0 0 1 3 3 2 2 0 0 1-2 2c-1.105 0-1.64-.444-2-1" />
                <path d="M15 14a5 5 0 0 0-7.584 2" />
                <path d="M9.964 6.825C8.019 7.977 9.5 13 8 15" />
              </svg>
              Calorie-counted and protein-packed to fit your health goals.
            </li>
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#fff"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-soup"
              >
                <path d="M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z" />
                <path d="M7 21h10" />
                <path d="M19.5 12 22 6" />
                <path d="M16.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.73 1.62" />
                <path d="M11.25 3c.27.1.8.53.74 1.36-.05.83-.93 1.2-.98 2.02-.06.78.33 1.24.72 1.62" />
                <path d="M6.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.74 1.62" />
              </svg>
              Made with fresh, high-quality ingredients, ensuring you get the
              nutrients you need.
            </li>
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#fff"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-clipboard-list"
              >
                <rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
                <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
                <path d="M12 11h4" />
                <path d="M12 16h4" />
                <path d="M8 11h.01" />
                <path d="M8 16h.01" />
              </svg>
              Tailored for various dietary preferences, including veg, non-veg,
              and vegan options.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default About;
